import {ErrorHandler, Injectable} from '@angular/core';
import * as Sentry from '@sentry/angular';
import {environment} from "../environments/environment";

@Injectable()
export class CustomSentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    Sentry.setTag('app_version', environment.version);

    Sentry.captureException(error);
    console.error(error);
  }
}
